/*======================================================================================
  Wholesale Gorilla - Quick order form customizations (Alex - Storetasker - 8/19/2019)
========================================================================================*/

window.addEventListener('load', function() {
  var quickOrderFormExists = !!$('.wsg-proxy-container').length;

  // Only initialize custom quick order form functionality if on the quick order form page
  if (quickOrderFormExists) {
    wsgQuickOrderForm.init();
    wsgQuickOrderForm.showAllPagesInPagination();
    wsgQuickOrderForm.createUpdateCartProxy();
    wsgQuickOrderForm.duplicatePagination();
    wsgQuickOrderForm.terminate();
  }
});

var wsgQuickOrderForm = {
  // Grab all needed quick order form elements, and set the form to show the initial loading animation
  init() {
    this.$wsgLoading = $('#wsg-spof-loading');
    this.$wsgContainer = $('#wsg-spof');
    this.$wsgForm = $('#spof-update-cart');
    this.$wsgPaginationContainer = $('#pagination');
    this.$wsgUpdateCartContainer = $('.wsg-update-container');
    this.$wsgUpdateCartButton = $('#wsg-cart-update');

    this.$wsgLoading.show();
    this.$wsgContainer.addClass('wsg-variant-off');
  },

  // Replace the partial pagination generated by default with a list of all page links
  showAllPagesInPagination() {
    var $paginationElement = this.$wsgPaginationContainer.children('span');
    var paginationExists = !!$paginationElement.children().length;

    // Pagination container has no elements, exit early
    if (!paginationExists) {
      return;
    }

    // Build new pagination links
    var url = new URL(window.location.href);
    var collection = url.searchParams.get('collection');
    var currentPage = parseInt(url.searchParams.get('page')) || 1;
    var firstPage = 1;
    var lastPage = parseInt($paginationElement.children().last().text());

    var newPaginationElementsHTML = '';

    for (var i = firstPage; i <= lastPage; i++) {
      var boldStyling = '';

      if (currentPage === i) {
        boldStyling = 'font-weight:bold;';
      }

      newPaginationElementsHTML += '<a href="/a/wsg/proxy/single-page-order?collection=' + collection + '&page=' + i + '" title style="padding-right:8px;word-break:break-word;display:inline-block;' + boldStyling + '">' + i + '</a>';
    }

    // Empty the old pagination elements and insert the new page links
    $paginationElement.empty();
    $paginationElement.append(newPaginationElementsHTML);
    $paginationElement.attr('style', 'word-break:break-word;');
  },

  // Create and add an update cart button to the top of the form which clicks the real submit button at the bottom of the form
  createUpdateCartProxy() {
    var proxyUpdateCartButton = '';
    proxyUpdateCartButton += '<div class="wsg-update-container-proxy" style="margin-top:30px;">';
    proxyUpdateCartButton += '<div style="display:block;clear:both;text-align:right;">';
    proxyUpdateCartButton += '<button id="wsg-cart-update-proxy" class="wsg-button-fix">Update Cart</button>';
    proxyUpdateCartButton += '</div>';
    proxyUpdateCartButton += '</div>';

    this.$wsgForm.prepend(proxyUpdateCartButton);

    // Click event for recently created proxy button
    this.$wsgForm.on('click', '#wsg-cart-update-proxy', function(e) {
      e.preventDefault();
      $(window).scrollTop(this.$wsgUpdateCartButton.offset().top - 300);
      this.$wsgUpdateCartButton.click();
    }.bind(this));
  },

  // Duplicate the pagination element and add it to the top of the form
  duplicatePagination() {
    var $clonedPaginationElement = this.$wsgPaginationContainer.clone();
    this.$wsgForm.prepend($clonedPaginationElement);
  },

  // Show the form and remove the loading animation
  terminate() {
    this.$wsgLoading.hide();
    this.$wsgContainer.removeClass('wsg-variant-off');
  }
}
